import { Component, OnInit } from '@angular/core';
import { CategoryPurposeModel, TallyNarrationDetails, TallyReceiptDetails, TallyReceiptHdr } from '../../models/tallyentry-model';
import { TallyReceiptService } from '../../services/tallyentry-service';
import { AccountsDetails, AccountsHeader, ChequeNoDTO, Finyearmst, Purpose, TallyReceiptModel, Txncategory } from '../../models/tallyentry-api-model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilityService } from '../../services/utility-service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { OrchestratorService } from '../../services/orchestrator-service';
import { EnumeratorList } from '../../models/enumerators-list';

@Component({
  selector: 'app-tally-entry',
  templateUrl: './tally-entry.component.html',
  styleUrls: ['./tally-entry.component.css']
})
export class TallyEntryComponent implements OnInit {

  public l_formDataTallyReceiptHdr: TallyReceiptHdr = new TallyReceiptHdr();
  public l_formDataTallyReceiptDetails: TallyReceiptDetails = new TallyReceiptDetails();
  public l_formDataTallyNarrationDetails: TallyNarrationDetails = new TallyNarrationDetails();
  public l_categoryPurposeSelect: CategoryPurposeModel[] = [];
  public l_categorySelect:  Txncategory[] = [];
  public l_purposeSelect: CategoryPurposeModel[] = [];
  public l_tallyEntryForm: FormGroup;
  public l_disableModeTranId: boolean = false;
  public l_disableModeBankName: boolean = false;
  public l_IsFrozen: boolean = false;
  public l_IsDivFrozen: boolean = false;
  public l_IsReceiptValid: boolean = false;

  public modeOfPaymentEnum: any[] = [];
  public salutationEnum: any[] = new EnumeratorList().salutationEnum;

  // public minDatePicker = new Date(2024, 3, 1);
  // public maxDatePicker = new Date(2025, 2, 31);
  public minDatePicker: Date;
  public maxDatePicker: Date;
  public l_displayAmount: number;

  public l_catgoryNameGlobal: string = null;
  public l_IsFixedDate: boolean = false;
  public l_IsDateDivFrozen: boolean = false;

  public l_notesList: string[] = [];
  public l_filteredNotesList: string[] = [];
  public l_autoyogprakashFiller: boolean;

  constructor(
    private l_tallyEntryFormBuilder: FormBuilder, 
    private l_TallyReceiptService: TallyReceiptService,
    private l_UtilityService: UtilityService,
    private l_datePipe: DatePipe,
    private l_orchestratorService: OrchestratorService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    await this.lFN_GetCategorySelect();
    await this.lFN_GetCategoryPurposeList();

    this.l_tallyEntryForm = this.l_tallyEntryFormBuilder.group({
      txncategory: ['', Validators.required],
      purpose: ['', Validators.required],
      bookNumber: ['', [Validators.required, Validators.pattern(/^\d{2,3}$/)]],
      amount: ['', [Validators.required, Validators.pattern(/^\d+(,\d+)*$/)]],
      receiptNbr: ['', [Validators.required, Validators.pattern(/^\d{1,5}$/)]],
      pinCd: ['', [Validators.pattern(/^\d{0,6}$/)]],
      mobileNbr: ['', [Validators.pattern(/^\d{10,15}$/)]],
      firstName: ['', [Validators.pattern(/^[a-zA-Z ]{2,}$/)]],
      middleName: ['', [Validators.pattern(/^[a-zA-Z ]{2,}$/)]],
      lastName: ['', [Validators.pattern(/^[a-zA-Z ]{2,}$/)]],
      panCrdNbr: ['', [Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]$/)]],
      aadharCrdNbr: ['', [Validators.pattern(/^\d{12}$/)]]
    });

    const navigationState = this.l_orchestratorService.lFN_GetStateData();
    if (navigationState) {
      let l_dataobject = navigationState.data;
      let l_formmode = navigationState.mode;
      if(l_formmode === 'edit') {
        await this.lFN_PopulateReceiptData(new TallyReceiptModel(l_dataobject));
      }
    }
    
    this.l_formDataTallyReceiptHdr.username = JSON.parse(sessionStorage.getItem('system_params')).registeredUser.fullName;
    await this.lFN_SetFinancialMinMaxDates();
  }

  lFN_validate(name: string): FormControl {
    return this.l_tallyEntryForm.get(name) as FormControl;
  }

  get l_FreezeLabel(): string {
    return this.l_IsFrozen ? 'Unfreeze Pane' : 'Freeze Pane';
  }

  get l_FixDateLabel(): string {
    return this.l_IsFixedDate ? 'Unset Date' : 'Set Fixed Date';
  }

  lFN_ToggleFreeze(): void {
    this.l_IsFrozen = !this.l_IsFrozen;
    if(this.l_IsFrozen === true) {
      this.l_IsDivFrozen = true;      
    } else {
      this.l_IsDivFrozen = false;
    }
  }

  lFN_ToggleFixDates(): void {
    this.l_IsFixedDate = !this.l_IsFixedDate;
    if(this.l_IsFixedDate === true) { 
      if(!this.l_formDataTallyReceiptDetails.txndate) {
        this.l_UtilityService.lFN_WarningToaster('Please select Txndate for receipts', 'Txndate Required');
        this.l_IsDateDivFrozen = false;
        this.l_IsFixedDate = false;
      } else {
        this.l_IsDateDivFrozen = true;
      }
    } else {
      this.l_IsDateDivFrozen = false;
      this.l_formDataTallyReceiptDetails.txndate = undefined;
    }
  }

  async lFN_GetCategorySelect() {
    let l_response = this.l_TallyReceiptService.lFN_GetCategory();
    l_response.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_categoryResponseList: Txncategory[] = [];
          for await (const l_category of JSON.parse(data.body)) {
            l_categoryResponseList.push(new Txncategory(l_category));
          }
          this.l_categorySelect = l_categoryResponseList;
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch category list.', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        //this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_GenerateModePaymentList() {
    this.l_formDataTallyReceiptDetails.modeOfPayment = "";
    let l_categoryIdSelected = this.l_formDataTallyReceiptHdr.txncategoryId;
    let l_purposeIdSelected = this.l_formDataTallyReceiptHdr.purposeId;
    let l_categoryName = this.l_categorySelect.find(l_category => (l_category.txncategoryId === l_categoryIdSelected)).name;
    let l_purposeName = this.l_purposeSelect.find(l_purpose=> (l_purpose.purposeId === l_purposeIdSelected)).purpose;
    //console.log('l_categoryName == ', l_categoryName);
    //console.log('l_purposeName == ', l_purposeName);
    this.modeOfPaymentEnum = await this.l_UtilityService.lFN_GetModePaymentList(l_categoryName, l_purposeName);
  }

  async lFN_GenerateReceiptNotesList() {
    this.l_formDataTallyNarrationDetails.notes = "";
    let l_categoryIdSelected = this.l_formDataTallyReceiptHdr.txncategoryId;
    let l_categoryName = this.l_categorySelect.find(l_category => (l_category.txncategoryId === l_categoryIdSelected)).name;
    this.l_notesList = await this.l_UtilityService.lFN_GetReceiptNotesList(l_categoryName);
    this.lFN_FilterNotes();
  }

  async lFN_EnableDisableFields(l_event) {
    //console.log(l_event.value);
    let l_modevalue = ((l_event.value) ? l_event.value: l_event);
    //console.log('l_modevalue == ', l_modevalue);
    if(l_modevalue === 'Cash') {
      this.l_disableModeTranId = true;
      this.l_disableModeBankName = true;
    } else if(l_modevalue === 'Cheque' || l_modevalue === 'DD') {
      this.l_disableModeTranId = false;
      this.l_disableModeBankName = false;
    } else if(l_modevalue === 'NEFT' || l_modevalue === 'RTGS') {
      this.l_disableModeTranId = false;
      this.l_disableModeBankName = true;
    }
  }

  async lFN_GetCategoryPurposeList() {
    let l_response = this.l_TallyReceiptService.lFN_GetCategoryPurpose();
    l_response.subscribe(async (data)=> {
      if(data.status == 200) {
        let l_categoryPurposeSelect: CategoryPurposeModel[] = [];
        for await (const iterator of JSON.parse(data.body)) {
          l_categoryPurposeSelect.push(iterator);
        }
        this.l_categoryPurposeSelect = l_categoryPurposeSelect;
      } else {
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch category purpose list.', 'Failure');
      }
    });
  }

  async lFN_GetPurposeSelect(l_txncategoryId) {
    let l_txnIdSelected = ((l_txncategoryId.value) ? l_txncategoryId.value : l_txncategoryId);
    let l_PurposeList = this.l_categoryPurposeSelect.filter((l_category) => l_category.txncategoryId === l_txnIdSelected);
    this.l_purposeSelect = l_PurposeList;
    await this.lFN_SetGlobalCategoryName(l_txnIdSelected);
  }

  async lFN_SetGlobalCategoryName(l_txncategoryIdSelected) {
    let l_categoryNameGl = this.l_categorySelect.find(l_category => (l_category.txncategoryId === l_txncategoryIdSelected)).name;
    console.log('l_categoryNameGl === ', l_categoryNameGl);
    this.l_catgoryNameGlobal = l_categoryNameGl;
  }

  lFN_ResetFormFields() {
    let l_txndateFixed = this.l_formDataTallyReceiptDetails.txndate;
    if(this.l_IsFrozen === false) {
      this.l_formDataTallyReceiptHdr = new TallyReceiptHdr();
      this.l_formDataTallyReceiptDetails = new TallyReceiptDetails();
      this.l_formDataTallyNarrationDetails = new TallyNarrationDetails();
      this.l_IsReceiptValid = false;
      this.l_formDataTallyReceiptHdr.username = JSON.parse(sessionStorage.getItem('system_params')).registeredUser.fullName;
      this.l_tallyEntryForm.reset();
    } else {
      this.l_formDataTallyReceiptDetails = new TallyReceiptDetails();
      this.l_formDataTallyNarrationDetails = new TallyNarrationDetails();
      this.l_IsReceiptValid = false;
    }
    if(this.l_IsDateDivFrozen === true) {
      this.l_formDataTallyReceiptDetails.txndate = l_txndateFixed;
    } else {
      l_txndateFixed = undefined;
    }
  }

  async lFN_SubmitTallyReceiptDtls() {
    if(this.lFN_ValidateInputs() == false) {
      return;
    }
    else if(await this.lFN_CheckValidTxnDate(this.l_formDataTallyReceiptDetails.txndate) == false) {
      this.l_UtilityService.lFN_ErrorToaster('Receipt Date out of Range of Financial Year', 'Receipt Date Improper');
      return;
    }
    else if(this.l_IsReceiptValid == false) {
      this.l_UtilityService.lFN_ErrorToaster('Please fill proper receiptNo.', 'Invalid ReceiptNo');
      return;
    } 
    else {
      this.l_UtilityService.lFN_ShowLoader();
      let l_tallyReceiptModel = this.lFN_createPayload();
      console.log('tallyReceiptModel payload === ', l_tallyReceiptModel);
      let response = this.l_TallyReceiptService.lFN_SaveTallyReceiptEntry(l_tallyReceiptModel);
      response.subscribe({
        next: (data) => {
          if (data.status == 200) {
            console.log('success_response: ', data);
            this.l_UtilityService.lFN_SuccessToaster('Receipt saved successfully.', 'Success');
            this.lFN_ResetFormFields();
            this.l_UtilityService.lFN_HideLoader();
          }
        },
        error: (l_error) => {
          console.error('error_response: ', l_error);
          if (l_error.status == 406) {
            this.l_UtilityService.lFN_ErrorToaster('Please fill proper receiptNo.', 'Duplicate ReceiptNo');
          } else if(l_error.status == 404) {
            this.l_UtilityService.lFN_ErrorToaster('Select proper purpose for category.', 'Improper Category Purpose selected');
          } else if(l_error.status == 400) {
            this.l_UtilityService.lFN_ErrorToaster(JSON.parse(l_error.error)?.msg, 'Receipt Save Failure');
          } else {
            this.l_UtilityService.lFN_ErrorToaster('Unable to save receipt.', 'Something went wrong.');
          }
          this.l_UtilityService.lFN_HideLoader();
        },
        complete: () => {
          console.log('Request completed');
          this.l_UtilityService.lFN_HideLoader();
        }
      });
    }
  }
  public l_catname = '';
  lFN_ValidateInputs() {
    //_checks_for_pariksha_category
    let l_categoryIdSelected = this.l_formDataTallyReceiptHdr.txncategoryId;
    let l_categoryName = this.l_categorySelect.find(l_category => (l_category.txncategoryId === l_categoryIdSelected)).name;
    console.log('l_categoryName === ', l_categoryName);

    if(!this.l_formDataTallyNarrationDetails.receiptNbr || this.l_formDataTallyNarrationDetails.receiptNbr == null) {
      this.l_UtilityService.lFN_WarningToaster('Receipt No. required', 'Warning');
      return false;
    }
    else if(!this.l_formDataTallyReceiptHdr.txncategoryId || this.l_formDataTallyReceiptHdr.txncategoryId == null || !this.l_formDataTallyReceiptHdr.purposeId || this.l_formDataTallyReceiptHdr.purposeId == null) {
      this.l_UtilityService.lFN_WarningToaster('Please select category and purpose', 'Warning');
      return false;
    }
    else if(!this.l_formDataTallyNarrationDetails.firstName || this.l_formDataTallyNarrationDetails.firstName == null) {
      this.l_UtilityService.lFN_WarningToaster('Firstname required', 'Warning');
      return false;
    }
    else if((!this.l_formDataTallyNarrationDetails.lastName || this.l_formDataTallyNarrationDetails.lastName == null) && l_categoryName !== 'Yogprakash') {
      this.l_UtilityService.lFN_WarningToaster('Lastname required', 'Warning');
      return false;
    }
    else if(!this.l_formDataTallyReceiptDetails.modeOfPayment || this.l_formDataTallyReceiptDetails.modeOfPayment == null) {
      this.l_UtilityService.lFN_WarningToaster('Mode of payment required', 'Warning');
      return false;
    }
    else if(!this.l_formDataTallyReceiptDetails.txndate || this.l_formDataTallyReceiptDetails.txndate == null) {
      this.l_UtilityService.lFN_WarningToaster('Transaction Date required', 'Warning');
      return false;
    }
    else if((!this.l_formDataTallyNarrationDetails.address || this.l_formDataTallyNarrationDetails.address == null || !this.l_formDataTallyNarrationDetails.city || this.l_formDataTallyNarrationDetails.city == null) 
      && l_categoryName !== 'Yogprakash') {
      this.l_UtilityService.lFN_WarningToaster('Address and City required', 'Warning');
      return false;
    }
    else if(!this.l_formDataTallyReceiptDetails.amount || this.l_formDataTallyReceiptDetails.amount == null) {
      this.l_UtilityService.lFN_WarningToaster('Amount required', 'Warning');
      return false;
    }
    else if(!this.l_formDataTallyReceiptHdr.bookNumber || this.l_formDataTallyReceiptHdr.bookNumber == null) {
      this.l_UtilityService.lFN_WarningToaster('Book Number required', 'Warning');
      return false;
    }
    else if(l_categoryName === 'Pariksha' && (!this.l_formDataTallyNarrationDetails.notes || this.l_formDataTallyNarrationDetails.notes == null)) {
      this.l_UtilityService.lFN_WarningToaster('Enter receipt number from donation book as notes', 'Please add notes');
      return false;
    }
    else {
      return true;
    }
  }

  lFN_createPayload() {
    console.log(this.l_formDataTallyReceiptHdr);
    console.log(this.l_formDataTallyReceiptDetails);
    console.log(this.l_formDataTallyNarrationDetails);
    let l_sessionData = JSON.parse(sessionStorage.getItem('system_params'));
    console.log('l_sessionData === ', l_sessionData);

    let l_receiptHdr = this.l_formDataTallyReceiptHdr;
    let l_receiptDetails = this.l_formDataTallyReceiptDetails;
    let l_receiptNarration = this.l_formDataTallyNarrationDetails;

    let l_formattedTxnDate = this.l_datePipe.transform(l_receiptDetails.txndate, 'yyyy-MM-dd');
    console.log(l_formattedTxnDate);

    let l_formattedAmount = this.lFN_FormatAmountForPayload(this.l_formDataTallyReceiptDetails.amount);
    console.log(l_formattedAmount);

    if(l_receiptDetails.modeOfPayment === 'Cheque') {
      //this.lFN_CheckDuplicateChequeNo(l_sessionData.finyearmst.finyearmstId, l_receiptHdr.txncategoryId, l_receiptDetails.modeTranId);
    }

    //_accountsHeader
    let l_accountsHeader = new AccountsHeader({
      accountsheaderId: ((l_receiptHdr.accountsheaderId) ? l_receiptHdr.accountsheaderId: null),
      finyearmst: new Finyearmst({
        // finyearmstId: l_receiptHdr.finyearmstId
        finyearmstId: l_sessionData.finyearmst.finyearmstId
      }),
      txncategory: new Txncategory({
        txncategoryId: l_receiptHdr.txncategoryId
      }),
      purpose: new Purpose({
        purposeId: l_receiptHdr.purposeId
      }),
      bookNo: l_receiptHdr.bookNumber,
      txndate: l_formattedTxnDate,
      //amount: l_receiptDetails.amount,
      amount: l_formattedAmount,
      modeOfPayment: l_receiptDetails.modeOfPayment,
      modeTranId: ((l_receiptDetails.modeTranId) ? l_receiptDetails.modeTranId: null),
      modeBankName: ((l_receiptDetails.modeBankName) ? l_receiptDetails.modeBankName: null),
      mapexternal: ((l_receiptDetails.mapexternal) ? l_receiptDetails.mapexternal: false),
      status: ((l_receiptDetails.status) ? l_receiptDetails.status: true),
      receiptLocked: ((l_receiptHdr.receiptLocked) ? l_receiptHdr.receiptLocked: false)
    });
    //_accountsDetails
    let l_accountsDetails = new AccountsDetails({
      accountsdetailsId: ((l_receiptHdr.accountsdetailsId) ? l_receiptHdr.accountsdetailsId: null),
      receiptNo: l_receiptNarration.receiptNbr,
      salutation: l_receiptNarration.salutation,
      firstName: l_receiptNarration.firstName,
      middleName: ((l_receiptNarration.middleName) ? l_receiptNarration.middleName: null),
      lastName: l_receiptNarration.lastName,
      address: l_receiptNarration.address,
      city: l_receiptNarration.city,
      pinCd: l_receiptNarration.pinCd,
      mobileNbr: l_receiptNarration.mobileNbr,
      email: l_receiptNarration.email,
      panCrdNbr: l_receiptNarration.panCrdNbr,
      aadharCrdNbr: l_receiptNarration.aadharCrdNbr,
      notes: l_receiptNarration.notes,
      collectedBy: l_receiptNarration.collectedBy
    });
    //_accountsReceiptModel
    let tallyReceiptModel = new TallyReceiptModel({
      accountsHeader: l_accountsHeader,
      accountsDetails: l_accountsDetails,
      receiptUpdate: ((l_receiptHdr.accountsheaderId) ? true: false)
    });
    return tallyReceiptModel;
  }

  async lFN_PopulateReceiptData(l_tallyReceiptModel: TallyReceiptModel) {
    this.l_UtilityService.lFN_ShowLoader();
    console.log('l_tallyReceiptModel === ', l_tallyReceiptModel.accountsHeader);
    console.log('l_tallyReceiptModel === ', l_tallyReceiptModel.accountsDetails);
    let l_sessionData = JSON.parse(sessionStorage.getItem('system_params'));
    console.log('l_sessionData === ', l_sessionData);

    let l_header = l_tallyReceiptModel.accountsHeader;
    let l_details = l_tallyReceiptModel.accountsDetails;

    this.l_formDataTallyReceiptHdr.accountsheaderId = l_header.accountsheaderId;
    this.l_formDataTallyReceiptHdr.accountsdetailsId = l_details.accountsdetailsId;
    this.l_formDataTallyReceiptHdr.finyearmstId = l_header.finyearmst.finyearmstId;
    
    this.l_formDataTallyReceiptHdr.txncategoryId = l_header.txncategory.txncategoryId;
    this.l_formDataTallyReceiptHdr.txncategory = l_header.txncategory.name;
    
    this.l_formDataTallyReceiptHdr.bookNumber = l_header.bookNo;
    this.l_formDataTallyReceiptHdr.username = l_sessionData.registeredUser.fullName;
    this.l_formDataTallyReceiptHdr.userId = 1;
    this.l_formDataTallyReceiptHdr.receiptLocked = l_header.receiptLocked;

    this.l_formDataTallyReceiptDetails.txndate = new Date(l_header.transaction.txnDate).toISOString();
    this.l_formDataTallyReceiptDetails.amount = l_header.amount;
    this.l_formDataTallyReceiptDetails.status = l_header.status;
    this.l_formDataTallyReceiptDetails.mapexternal = l_header.mapexternal;

    this.l_formDataTallyNarrationDetails.receiptNbr = l_details.receiptNo;
    this.l_formDataTallyNarrationDetails.salutation = l_details.salutation;
    this.l_formDataTallyNarrationDetails.firstName = l_details.firstName;
    this.l_formDataTallyNarrationDetails.middleName = l_details.middleName;
    this.l_formDataTallyNarrationDetails.lastName = l_details.lastName;
    this.l_formDataTallyNarrationDetails.address = l_details.address;
    this.l_formDataTallyNarrationDetails.city = l_details.city;
    this.l_formDataTallyNarrationDetails.pinCd = l_details.pinCd;
    this.l_formDataTallyNarrationDetails.mobileNbr = l_details.mobileNbr;
    this.l_formDataTallyNarrationDetails.email = l_details.email;
    this.l_formDataTallyNarrationDetails.panCrdNbr = l_details.panCrdNbr;
    this.l_formDataTallyNarrationDetails.aadharCrdNbr = l_details.aadharCrdNbr;
    this.l_formDataTallyNarrationDetails.notes = l_details.notes;
    this.l_formDataTallyNarrationDetails.collectedBy = l_details.collectedBy;
    //_setting_valid_receiptNo
    this.l_IsReceiptValid = true;

    setTimeout(async () => {
      await this.lFN_GetPurposeSelect(l_header.txncategory.txncategoryId);
      this.l_formDataTallyReceiptHdr.purposeId = l_header.purpose.purposeId;
      this.l_formDataTallyReceiptHdr.purpose = l_header.purpose.name;
      await this.lFN_GenerateModePaymentList();
      await this.lFN_EnableDisableFields(l_header.modeOfPayment);
      this.l_formDataTallyReceiptDetails.modeOfPayment = l_header.modeOfPayment;
      this.l_formDataTallyReceiptDetails.modeTranId = l_header.modeTranId;
      this.l_formDataTallyReceiptDetails.modeBankName = l_header.modeBankName;
      this.l_UtilityService.lFN_HideLoader();
    }, 2000);

  }

  async lFN_VerifyReceiptNbr() {
    let l_sessionData = JSON.parse(sessionStorage.getItem('system_params'));
    let l_finyearmstIdSeleted = l_sessionData.finyearmst.finyearmstId;
    let l_receiptNoSelected = this.l_formDataTallyNarrationDetails.receiptNbr;
    let l_txncategoryIdSelected = this.l_formDataTallyReceiptHdr.txncategoryId;
    let l_accountsheaderId = this.l_formDataTallyReceiptHdr.accountsheaderId;

    let l_receiptVerifyPayload = {
      finyearmstId: l_finyearmstIdSeleted,
      txncategoryId: l_txncategoryIdSelected,
      receiptNo: l_receiptNoSelected,
      accountsheaderId: l_accountsheaderId
    };
    let l_receiptValidationResponse = this.l_TallyReceiptService.lFN_ValidateReceiptNbr(l_receiptVerifyPayload);
    l_receiptValidationResponse.subscribe({
      next: (data) => {
        if (data.status == 200) {
          console.log('success_response: ', data);
          this.l_IsReceiptValid = true;
          this.l_UtilityService.lFN_SuccessToaster('Receipt number verified successfully.', 'Success');
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_IsReceiptValid = false;
        if (l_error.status == 406) {
          this.l_UtilityService.lFN_ErrorToaster('Insufficient data for receipt validation.', 'Invalid ReceiptNo');
        } else {
          this.l_UtilityService.lFN_ErrorToaster('Receipt number already exists.', 'Failure');
        }
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  lFN_OnToggleChange(event: any) {
    this.l_formDataTallyReceiptDetails.mapexternal = event.checked;
    console.log('this.l_formDataTallyReceiptDetails.mapexternal == ', this.l_formDataTallyReceiptDetails.mapexternal);
  }

  lFN_FormatAmount(l_event: any) {
    console.log('l_event.target.value == ', l_event.target.value);
    let l_eventvalue = l_event.target.value;
    const formattedValue = this.l_UtilityService.lFN_FormatCurrency(l_eventvalue);
    l_event.target.value = formattedValue;
  }

  lFN_FormatAmountForPayload(l_amount: any) {
    console.log('l_amount == ', l_amount);
    let amountStr = l_amount.toString();
    let numericValue = amountStr.replace(/,/g, '');
    numericValue = numericValue.replace(/[^0-9.]/g, '');
    console.log('l_amount numericValue == ', parseInt(numericValue));
    return parseInt(numericValue);
  }

  async lFN_CheckDuplicateChequeNo(financialYearId: number, txncatId: number, chequeNumber: string) {
    let l_chequeDupPayload = new ChequeNoDTO({
      finyearmstId: financialYearId,
      txncategoryId: txncatId,
      chequeNo: chequeNumber
    });
    console.log('l_chequeDupPayload === ', l_chequeDupPayload);
    let l_userConfirmation = this.l_UtilityService.lFN_ShowPopup('Confirmation', 'Duplicate Cheque Number found for selected Category');
    console.log('l_userConfirmation === ', l_userConfirmation);
    
    let l_chequeValidationResponse = this.l_TallyReceiptService.lFN_GetChequeDuplicacy(l_chequeDupPayload);
    l_chequeValidationResponse.subscribe({
      next: (data) => {
        if (data.status == 200) {
          console.log('cheque no. validate_response: ', data);
          this.l_UtilityService.lFN_ShowPopup('Confirmation', 'Duplicate Cheque Number found for selected Category');
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        if (l_error.status == 406) {
          //_show_confirmation_popup
        }
      },
      complete: () => {
        console.log('cheque validations completed');
      }
    });
  }

  lFN_FilterNotes() {
    const l_filterValue = this.l_formDataTallyNarrationDetails.notes.toLowerCase();
    this.l_filteredNotesList = this.l_notesList.filter(note => note.toLowerCase().includes(l_filterValue));
  }

  async lFN_SetFinancialMinMaxDates() {
    const activeFinyear = JSON.parse(sessionStorage.getItem('system_params'))?.finyearmst;

    if (activeFinyear && activeFinyear.finyear) {
      const [startYearStr, endYearStr] = activeFinyear.finyear.split('-');

      const startYear = parseInt(`${startYearStr}`);
      const endYear = parseInt(`20${endYearStr}`);

      this.minDatePicker = new Date(startYear, 3, 1);
      this.maxDatePicker = new Date(endYear, 2, 31);
      console.log('minDatePicker and maxDatePicker ==> ', this.minDatePicker + ' ' + this.maxDatePicker);
    }
  }

  async lFN_CheckValidTxnDate(receiptTxnDate: string) {
    console.log('this.minDatePicker ==> ', this.minDatePicker);
    console.log('this.maxDatePicker ==> ', this.maxDatePicker);
    console.log('receiptTxnDate ==> ', receiptTxnDate);

    const txnDate = new Date(receiptTxnDate);
    const minDate = new Date(this.minDatePicker);
    const maxDate = new Date(this.maxDatePicker);

    if (txnDate >= minDate && txnDate <= maxDate) {
      console.log('receiptTxnDate is within the allowed range');
      return true;
    } else {
      console.log('receiptTxnDate is OUTSIDE the allowed range');
      return false;
    }
  }

}

